// Main style objects for the resume template

export const colors = {
  primary: "#bd5d38",
  primaryHover: "#974a2d",
  dark: "#343a40",
  gray: "#6c757d",
  lightGray: "#f8f9fa",
  white: "#fff",
  black: "#000",
  yellow: "#ffc107",
}

export const fonts = {
  heading:
    '"Saira Extra Condensed", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  body: 'Muli, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
}

export const common = {
  section: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center", // center horizontally
    flexDirection: "column",  // stack children vertically
    padding: "5rem 1rem",
    maxWidth: "75rem",
    margin: "0 auto", // center section itself
    minHeight: "100vh", // ensure vertical centering
    
  },
  sectionContent: {
    width: "100%",
    flexDirection: "column",
    alignItems: "center", // center children horizontally
  },
  subheading: {
    fontFamily: fonts.heading,
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: "1.5rem",
    marginBottom: "1rem",
  },
  hr: {
    margin: 0,
    border: 0,
    borderTop: "1px solid rgba(0, 0, 0, 0.1)",
  },
  lead: {
    fontSize: "1.15rem",
    fontWeight: 400,
  },
}

export const navStyles = {
  nav: {
    backgroundColor: colors.primary,
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 10,
    color: colors.white,
    padding: "0.5rem 1rem",
  },
  navLg: {
    width: "17rem",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
  },
  brand: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  brandLg: {
    display: "flex",
    flexDirection: "column",
    padding: "0.5rem",
  },
  navList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  navItem: {
    marginBottom: "0.5rem",
  },
  navLink: {
    fontWeight: 800,
    letterSpacing: "0.05rem",
    textTransform: "uppercase",
    color: "rgba(255, 255, 255, 0.7)",
    textDecoration: "none",
    display: "block",
    padding: "0.5rem 0",
  },
  navLinkActive: {
    color: colors.white,
  },
  toggleButton: {
    background: "none",
    border: "none",
    color: colors.white,
    cursor: "pointer",
  },
  profileImg: {
    maxWidth: "10rem",
    maxHeight: "10rem",
    borderRadius: "30%",
    border: "0.5rem solid rgba(255, 255, 255, 0.2)",
    marginBottom: "0.5rem",
  },
}

export const aboutStyles = {
  name: {
    fontSize: "4rem",
    lineHeight: 1,
    textTransform: "uppercase",
    fontFamily: fonts.heading,
    fontWeight: 700,
    marginBottom: 0,
    color: colors.dark,
  },
  nameSpan: {
    color: colors.primary,
  },
  contactInfo: {
    marginBottom: "1.5rem",
    marginTop: "1rem",
  },
  email: {
    color: colors.primary,
    textDecoration: "none",
  },
  socialIcons: {
    display: "flex",
    flexWrap: "wrap",
  },
  socialIcon: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: "3.5rem",
    width: "3.5rem",
    backgroundColor: colors.dark,
    color: colors.white,
    borderRadius: "100%",
    fontSize: "1.5rem",
    marginRight: "1.5rem",
    textDecoration: "none",
  },
}

export const experienceStyles = {
  item: {
    marginBottom: "2rem",
  },
  title: {
    fontSize: "2rem",
    fontFamily: fonts.heading,
    fontWeight: 700,
    textTransform: "uppercase",
    color: colors.dark,
    marginBottom: "0.25rem",
  },
  company: {
    fontFamily: fonts.heading,
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: "1.5rem",
    marginBottom: "1rem",
  },
  period: {
    color: colors.primary,
    fontWeight: 500,
  },
}

export const educationStyles = {
  item: {
    marginBottom: "2rem",
  },
  school: {
    fontSize: "2rem",
    fontFamily: fonts.heading,
    fontWeight: 700,
    textTransform: "uppercase",
    color: colors.dark,
    marginBottom: "0.25rem",
  },
  degree: {
    fontFamily: fonts.heading,
    textTransform: "uppercase",
    fontWeight: 500,
    fontSize: "1.5rem",
    marginBottom: "1rem",
  },
  field: {
    marginBottom: "0.5rem",
  },
  gpa: {
    marginBottom: "0.5rem",
  },
  period: {
    color: colors.primary,
    fontWeight: 500,
  },
}

export const skillsStyles = {
  devIcons: {
    display: "flex",
    flexWrap: "wrap",
    listStyle: "none",
    padding: 0,
    marginBottom: "2rem",
  },
  devIcon: {
    fontSize: "3rem",
    marginRight: "1rem",
    marginBottom: "1rem",
  },
  workflowList: {
    listStyle: "none",
    padding: 0,
    marginLeft: "1.5rem",
  },
  workflowItem: {
    position: "relative",
    marginBottom: "0.5rem",
  },
  checkIcon: {
    position: "absolute",
    left: "-1.5rem",
    top: "0.25rem",
    color: colors.primary,
  },
}

export const interestsStyles = {
  paragraph: {
    marginBottom: "1rem",
  },
}

export const awardsStyles = {
  list: {
    listStyle: "none",
    padding: 0,
    marginLeft: "1.5rem",
  },
  item: {
    position: "relative",
    marginBottom: "0.5rem",
  },
  trophyIcon: {
    position: "absolute",
    left: "-1.5rem",
    top: "0.25rem",
    color: colors.yellow,
  },
}

export const mediaQueries = {
  lg: "@media (min-width: 992px)",
}

export const pageStyles = {
  main: {
    fontFamily: fonts.body,
    color: colors.gray,
    paddingTop: "3.375rem",
  },
  mainLg: {
    paddingTop: 0,
    paddingLeft: "17rem",
  },
}
